import type { AccessoryComparisonBrand, AccessoryComparisonProductImage } from "./accessoryEquivalencies";

type ProductImageAsset = Omit<AccessoryComparisonProductImage, "alt">;

export const accessoryComparisonProductImages: Record<string, ProductImageAsset> = {
  "1:Bobrick": {
    src: "/manus-storage/01-bobrick-b-165-series_eebdeb7e.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-01-bobrick",
  },
  "1:ASI": {
    src: "/manus-storage/01-asi-0620-series_88b687dd.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-01-asi",
  },
  "1:Bradley": {
    src: "/manus-storage/01-bradley-781-series_cc02faf2.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-01-bradley",
  },
  "2:Bobrick": {
    src: "/manus-storage/02-bobrick-b-36903_8a6fbc56.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-02-bobrick",
  },
  "2:ASI": {
    src: "/manus-storage/02-asi-0469_84c57371.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-02-asi",
  },
  "2:Bradley": {
    src: "/manus-storage/02-bradley-234-series-234-00_5589c5eb.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-02-bradley",
  },
  "3:Bobrick": {
    src: "/manus-storage/03-bobrick-b-167-series_fe43686e.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-03-bobrick",
  },
  "3:ASI": {
    src: "/manus-storage/03-asi-0640_595ad433.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-03-asi",
  },
  "3:Bradley": {
    src: "/manus-storage/03-bradley-elvari-led-mirrors_7726c434.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-03-bradley",
  },
  "4:Bobrick": {
    src: "/manus-storage/04-bobrick-commercial-mirrors-family_58d814c6.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-04-bobrick",
  },
  "4:ASI": {
    src: "/manus-storage/04-asi-mirrors-category_c15dcdd8.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-04-asi",
    representative: true,
    note: "Representative ASI Chan-Lok mirror image used for the broad ASI Mirrors category row because the supplied category URL no longer resolves.",
  },
  "4:Bradley": {
    src: "/manus-storage/04-bradley-mirrors-category_6122fa6d.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-04-bradley",
  },
  "5:Bobrick": {
    src: "/manus-storage/05-bobrick-b-6107-series_7ee3ba13.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-05-bobrick",
  },
  "5:ASI": {
    src: "/manus-storage/05-asi-1214-2-with-1214-1-flanges_ed6d5ebc.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-05-asi",
  },
  "5:Bradley": {
    src: "/manus-storage/05-bradley-9538-9539-series_b7ccbcbb.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-05-bradley",
    note: "Current Bradley 9539 page explicitly documents both the 9538 1-inch and 9539 1-1/4-inch concealed-mount rod family.",
  },
  "6:Bobrick": {
    src: "/manus-storage/06-bobrick-b-47069c_82f843f5.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-06-bobrick",
  },
  "6:ASI": {
    src: "/manus-storage/06-asi-0864-f_3fa80ed1.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-06-asi",
  },
  "6:Bradley": {
    src: "/manus-storage/06-bradley-407-series-407-114000_7eb523c9.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-06-bradley",
  },
  "7:Bobrick": {
    src: "/manus-storage/07-bobrick-b-3974_444bef8e.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-07-bobrick",
  },
  "7:ASI": {
    src: "/manus-storage/07-asi-0469_4f591505.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-07-asi",
  },
  "7:Bradley": {
    src: "/manus-storage/07-bradley-234-series-234-00_d8d73e78.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-07-bradley",
  },
  "8:Bobrick": {
    src: "/manus-storage/08-bobrick-paper-towel-dispensers-family_c9e813e7.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-08-bobrick",
  },
  "8:ASI": {
    src: "/manus-storage/08-asi-0210_b65cd855.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-08-asi",
  },
  "8:Bradley": {
    src: "/manus-storage/08-bradley-252-series_c444ac40.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-08-bradley",
  },
  "9:Bobrick": {
    src: "/manus-storage/09-bobrick-b-39617_a4e4a9b3.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-09-bobrick",
  },
  "9:ASI": {
    src: "/manus-storage/09-asi-0469_a02ab0bf.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-09-asi",
  },
  "9:Bradley": {
    src: "/manus-storage/09-bradley-234-series_69e27194.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-09-bradley",
  },
  "10:Bobrick": {
    src: "/manus-storage/10-bobrick-b-6806-series_0b5d82b6.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-10-bobrick",
  },
  "10:ASI": {
    src: "/manus-storage/10-asi-3800-3801-series_3cb352bd.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-10-asi",
  },
  "10:Bradley": {
    src: "/manus-storage/10-bradley-812-series_cef7b4be.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-10-bradley",
  },
  "11:Bobrick": {
    src: "/manus-storage/11-bobrick-b-290-series_1915f505.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-11-bobrick",
  },
  "11:ASI": {
    src: "/manus-storage/11-asi-0600-series_5f63b6c5.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-11-asi",
  },
  "11:Bradley": {
    src: "/manus-storage/11-bradley-780-series_a14edf59.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-11-bradley",
  },
  "12:Bobrick": {
    src: "/manus-storage/12-bobrick-b-6717_fbbde5cc.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-12-bobrick",
  },
  "12:ASI": {
    src: "/manus-storage/12-asi-0751_087559d8.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-12-asi",
  },
  "12:Bradley": {
    src: "/manus-storage/12-bradley-9114-stainless-steel-single-robe-hook_d1e6a1d6.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-12-bradley",
  },
  "13:Bobrick": {
    src: "/manus-storage/13-bobrick-b-207-series_00e500b7.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-13-bobrick",
  },
  "13:ASI": {
    src: "/manus-storage/13-asi-1214-2-concealed-option_f476e29c.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-13-asi",
  },
  "13:Bradley": {
    src: "/manus-storage/13-bradley-9538-9539-series_fef10ffe.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-13-bradley",
    note: "Current Bradley 9539 page explicitly documents both the 9538 1-inch and 9539 1-1/4-inch concealed-mount rod family.",
  },
  "14:Bobrick": {
    src: "/manus-storage/14-bobrick-toilet-tissue-dispensers-family_d9e47598.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-14-bobrick",
  },
  "14:ASI": {
    src: "/manus-storage/14-asi-0032_02cc7bd9.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-14-asi",
  },
  "14:Bradley": {
    src: "/manus-storage/14-bradley-5402-series_d45e5f68.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-14-bradley",
  },
  "15:Bobrick": {
    src: "/manus-storage/15-bobrick-b-5806-series_6b4de784.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-15-bobrick",
  },
  "15:ASI": {
    src: "/manus-storage/15-asi-3700-3701-series_05ae495f.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-15-asi",
  },
  "15:Bradley": {
    src: "/manus-storage/15-bradley-812-series-1-1-2-only_bd2835af.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-15-bradley",
  },
  "16:Bobrick": {
    src: "/manus-storage/16-bobrick-b-76717_cbce99fb.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-16-bobrick",
  },
  "16:ASI": {
    src: "/manus-storage/16-asi-0751-a_379f61b5.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-16-asi",
  },
  "16:Bradley": {
    src: "/manus-storage/16-bradley-9114-stainless-steel-single-robe-hook_4937c47b.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-16-bradley",
  },
  "17:Bobrick": {
    src: "/manus-storage/17-bobrick-b-2111_b22d4bbb.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-17-bobrick",
  },
  "17:ASI": {
    src: "/manus-storage/17-asi-0347_3ab342f2.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-17-asi",
  },
  "17:Bradley": {
    src: "/manus-storage/17-bradley-wall-mounted-horizontal-tank-soap-dispenser-6542_e96da83b.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-17-bradley",
  },
  "18:Bobrick": {
    src: "/manus-storage/18-bobrick-b-270_4156aa6d.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-18-bobrick",
  },
  "18:ASI": {
    src: "/manus-storage/18-asi-0852_239599de.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-18-asi",
  },
  "18:Bradley": {
    src: "/manus-storage/18-bradley-satin-finish-surface-mounted-napkin-disposal-4781-11_9f8e607b.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-18-bradley",
  },
  "19:Bobrick": {
    src: "/manus-storage/19-bobrick-b-221_d3f82368.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-19-bobrick",
  },
  "19:ASI": {
    src: "/manus-storage/19-asi-0477-sm_1f2331e6.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-19-asi",
  },
  "19:Bradley": {
    src: "/manus-storage/19-bradley-high-capacity-surface-mounted-seat-cover-dispenser-583_0ec2b7a8.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-19-bradley",
  },
  "20:Bobrick": {
    src: "/manus-storage/20-bobrick-shower-seats-family_9a5b182d.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-20-bobrick",
  },
  "20:ASI": {
    src: "/manus-storage/20-asi-8207_76782c17.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-20-asi",
  },
  "20:Bradley": {
    src: "/manus-storage/20-bradley-folding-phenolic-shower-seat-9562-9591-family_e4a639cb.webp",
    width: 720,
    height: 720,
    provenanceKey: "workbook-rank-20-bradley",
  },
};

export function getAccessoryComparisonProductImage(
  rank: number,
  brand: AccessoryComparisonBrand,
  alt: string,
): AccessoryComparisonProductImage {
  const asset = accessoryComparisonProductImages[`${rank}:${brand}`];
  if (!asset) {
    throw new Error(`Missing accessory comparison product image for rank ${rank}, brand ${brand}`);
  }
  return { ...asset, alt };
}
